import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { useTranslation, Link } from "gatsby-plugin-react-i18next";

import * as styles from "../../assets/sass/modules/_sub-menu.module.scss";

const MenuServices = () => {
  const data = useStaticQuery(graphql`
    query ($language: String) {
      locales: allLocale(filter: { language: { eq: $language } }) {
        edges {
          node {
            ns
            data
            language
          }
        }
      }
      servicesCSD: allMarkdownRemark(
        filter: {
          frontmatter: {
            tag: { eq: "sub-service" }
            slug: { ne: null }
            parentUid: { eq: 900001 }
          }
        }
        sort: { frontmatter: { order: ASC } }
      ) {
        nodes {
          frontmatter {
            menuTitle
            slug
          }
          id
        }
      }

      servicesAT: allMarkdownRemark(
        filter: {
          frontmatter: {
            tag: { eq: "sub-service" }
            slug: { ne: null }
            parentUid: { eq: 900002 }
          }
        }
        sort: { frontmatter: { order: ASC } }
      ) {
        nodes {
          frontmatter {
            menuTitle
            slug
          }
          id
        }
      }
    }
  `);

  const { t } = useTranslation();

  const servicesCSD = data.servicesCSD.nodes;
  const servicesAT = data.servicesAT.nodes;

  return (
    <div className="container">
      <div className={styles.menuPanel}>
        <div className="row">
          <div className={`${styles.menuGroup} col-12 col-lg-auto`}>
            <div className="d-flex m-bottom-4">
              <div className={styles.icon}>
                <img src="/images/icon-innovation-advisory.png" alt="" />
              </div>
              <div>
                <Link
                  to="/services/innovation-advisory"
                  className={`${styles.category} m-bottom-1`}
                >
                  {t("INNOVATION_ADVISORY")}
                </Link>
                <p className="featureDescription">
                  {t("INNOVATION_ADVISORY_DESCRIPTION")}
                </p>
              </div>
            </div>
            <div className="d-flex">
              <div className={styles.icon}>
                <img src="/images/icon-team-augmentation.png" alt="" />
              </div>
              <div>
                <Link
                  to="/services/team-augmentation"
                  className={`${styles.category} m-bottom-1`}
                >
                  {t("TEAM_AUGMENTATION")}
                </Link>
                <p className="featureDescription">
                  {t("TEAM_AUGMENTATION_DESCRIPTION")}
                </p>
              </div>
            </div>
          </div>
          <div className={`${styles.menuGroup} col-12 col-lg-auto`}>
            <div className="d-flex">
              <div className={styles.icon}>
                <img
                  src="/images/icon-custom-software-development.png"
                  alt=""
                />
              </div>
              <div>
                <Link
                  to="/services/custom-software-development"
                  className={styles.category}
                >
                  {t("CUSTOM_SOFTWARE_DEVELOPMENT")}
                </Link>
                <ul className={styles.linkList}>
                  {servicesCSD.map((item, index) => (
                    <li key={index}>
                      <Link to={item.frontmatter.slug}>
                        {item.frontmatter.menuTitle}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className={`${styles.menuGroup} col-12 col-lg-auto`}>
            <div className="d-flex">
              <div className={styles.icon}>
                <img src="/images/icon-advanced-technologies.png" alt="" />
              </div>
              <div>
                <Link
                  to="/services/advanced-technologies"
                  className={styles.category}
                >
                  {t("ADVANCED_TECHNOLOGIES")}
                </Link>
                <ul className={styles.linkList}>
                  {servicesAT.map((item, index) => (
                    <li key={index}>
                      <Link to={item.frontmatter.slug}>
                        {item.frontmatter.menuTitle}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuServices;
